import { useAppSelector } from "./reduxHook";
import { useListAlertsQuery } from "../actions/alertsInQuery";
import { useListDevicesQuery } from "../actions/devicesInQuery";

export const useAppAlerts = (options?: { skip?: boolean }) => {
  const filters = useAppSelector((state) => state.alertsSlice);
  const { data: devices } = useListDevicesQuery();

  const deviceUuids =
    devices?.items.flatMap((device) => (device.uuid ? [device.uuid] : [])) ||
    [];

  return useListAlertsQuery(
    {
      page: filters.page,
      pageSize: filters.pageSize,
      devices: deviceUuids,
      tags: filters.tags,
      levels: filters.levels,
      buildEnv: filters.buildEnv,
    },
    {
      skip: options?.skip || devices?.items.length === 0,
    },
  );
};
